import React from 'react';
import FadeIn from '../ui/FadeIn';
import Divider from '../ui/Divider';
import SafeIcon from '../common/SafeIcon';
import * as FiIcons from 'react-icons/fi';

const { FiCalendar, FiHeart, FiClock } = FiIcons;

const WhyMatters = () => {
  const cards = [
    {
      icon: FiCalendar,
      title: "Peak Elegance",
      desc: "October in Southern California offers the most coveted atmosphere, with golden afternoon light and perfect evening temperatures."
    },
    {
      icon: FiHeart,
      title: "Historic Estate",
      desc: "Our Spanish Revival architecture and manicured olive groves provide a backdrop that feels like a private family estate."
    },
    {
      icon: FiClock,
      title: "Immediate Access",
      desc: "Skip the typical 18-month waitlist and host your dream wedding this autumn with our dedicated planning support."
    }
  ];

  return (
    <section className="py-20 md:py-32 px-6 bg-charcoal relative">
      <div className="max-w-6xl mx-auto">
        <FadeIn className="text-center mb-16 md:mb-24">
          <p className="text-gold tracking-[0.4em] text-[11px] uppercase mb-4">The Opportunity</p>
          <h3 className="font-serif text-3xl md:text-5xl text-ivory/90 mb-6">A Rare Chance for an <span className="italic">Autumn Celebration</span></h3>
          <Divider className="mt-8 opacity-20" />
        </FadeIn>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-8 md:gap-12">
          {cards.map((card, index) => (
            <FadeIn key={index} delay={0.2 * index} className="h-full">
              <div className="gold-frame p-8 md:p-12 h-full flex flex-col items-center md:items-start text-center md:text-left bg-black/20 group hover:bg-gold/5 transition-all duration-700">
                <SafeIcon icon={card.icon} className="text-gold text-2xl mb-6 opacity-70 group-hover:opacity-100 transition-opacity" />
                <h4 className="font-serif text-xl md:text-2xl text-ivory mb-4 group-hover:text-gold transition-colors">{card.title}</h4>
                <p className="text-stone font-light leading-relaxed text-[16px] md:text-[17px] opacity-80">{card.desc}</p>
              </div>
            </FadeIn>
          ))}
        </div>
      </div>
    </section>
  );
};

export default WhyMatters;